<template>
  <SvgBase iconName="IconLock" width="22" height="22">
    <path
      d="M14.9214 8.77344H2.19622C1.60029 8.77344 1.11719 9.34999 1.11719 10.0612V19.6943C1.11719 20.4055 1.60029 20.9821 2.19622 20.9821H14.9214C15.5173 20.9821 16.0004 20.4055 16.0004 19.6943V10.0612C16.0004 9.34999 15.5173 8.77344 14.9214 8.77344Z"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M4.55904 8.77392V5.01763C4.52878 4.50078 4.60981 3.9835 4.79719 3.49742C4.98458 3.01135 5.27436 2.56669 5.64885 2.19063C6.02333 1.81458 6.47466 1.51503 6.97519 1.31031C7.47571 1.10559 8.01492 1 8.55987 1C9.10482 1 9.64407 1.10559 10.1446 1.31031C10.6451 1.51503 11.0964 1.81458 11.4709 2.19063C11.8454 2.56669 12.1352 3.01135 12.3225 3.49742C12.5099 3.9835 12.591 4.50078 12.5607 5.01763V8.77392"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M8.55824 15.4359C9.50668 15.4359 10.2755 14.6904 10.2755 13.7707C10.2755 12.851 9.50668 12.1055 8.55824 12.1055C7.6098 12.1055 6.84094 12.851 6.84094 13.7707C6.84094 14.6904 7.6098 15.4359 8.55824 15.4359Z"
      fill="white"
    />
    <path d="M10.2755 17.6546H6.84094L8.27202 14.3242H8.84446L10.2755 17.6546Z" fill="white" />
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconLock extends Vue {}
</script>
